export enum PushToDmsStatus {
    Ready = 'ready',
    Sending = 'sending',
    Failure = 'failure'
}
